// src/componentes/common/KyeConfirm.jsx
import React, { useState, useEffect, useRef, useCallback } from "react";
import { _registerDialogHandler } from "./dialogService";
import "./KyeConfirm.css";

export default function KyeConfirm() {
  const [dialog, setDialog] = useState(null);
  const [inputVal, setInputVal] = useState("");
  const inputRef = useRef(null);
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    _registerDialogHandler((d) => {
      setInputVal(d.defaultValue ?? "");
      setDialog(d);
    });
  }, []);

  useEffect(() => {
    if (!dialog) return;
    if (dialog.type === "prompt" && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    } else if (confirmBtnRef.current) {
      confirmBtnRef.current.focus();
    }
  }, [dialog]);

  const handleConfirm = useCallback(() => {
    if (!dialog) return;
    dialog.resolve(dialog.type === "prompt" ? inputVal : true);
    setDialog(null);
  }, [dialog, inputVal]);

  const handleCancel = useCallback(() => {
    if (!dialog) return;
    dialog.resolve(dialog.type === "prompt" ? null : false);
    setDialog(null);
  }, [dialog]);

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Enter") handleConfirm();
      if (e.key === "Escape") handleCancel();
    },
    [handleConfirm, handleCancel]
  );

  if (!dialog) return null;

  return (
    <div className="kye-dialog-backdrop" onClick={handleCancel}>
      <div
        className="kye-dialog"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleKey}
      >
        {dialog.titulo && <h3 className="kye-dialog__title">{dialog.titulo}</h3>}

        <p className="kye-dialog__message">{dialog.message}</p>

        {Array.isArray(dialog.detalles) && dialog.detalles.length > 0 && (
          <dl className="kye-dialog__detalles">
            {dialog.detalles.map((d, i) => (
              <div key={i} className="kye-dialog__detalle-row">
                <dt>{d.label}</dt>
                <dd>{d.value}</dd>
              </div>
            ))}
          </dl>
        )}

        {dialog.type === "prompt" && (
          <input
            ref={inputRef}
            className="kye-dialog__input"
            value={inputVal}
            onChange={(e) => setInputVal(e.target.value)}
          />
        )}

        <div className="kye-dialog__actions">
          <button className="kye-dialog__btn kye-dialog__btn--cancel" onClick={handleCancel}>
            Cancelar
          </button>
          <button
            ref={confirmBtnRef}
            className={`kye-dialog__btn ${dialog.peligro ? "kye-dialog__btn--danger" : "kye-dialog__btn--confirm"}`}
            onClick={handleConfirm}
          >
            {dialog.confirmText || (dialog.type === "prompt" ? "Aceptar" : "Confirmar")}
          </button>
        </div>
      </div>
    </div>
  );
}
